module.exports = __webpack_public_path__ + "aa7de0183be8d7c2786d9da062cc80dd.svg";